export default __webpack_public_path__ + "static/media/69.2d515e13.png";